module.exports = __webpack_public_path__ + "img/no-image.63d6e67f.svg";